// extracted by mini-css-extract-plugin
module.exports = {"container":"allocatedMembers_container__-om7C"};